export default "/images/crop.svg?cfaa0f803bed5fb9ae47e47f515e4499";